<nav
    class="gtmsection-resource-details-navigation"
    [ngClass]="{
        'full-view-style': !resourceService.focusView,
        'focus-view-style': resourceService.focusView,
    }"
>
    <div
        [ngClass]="{ 'no-language': resource.selectedAsset.medias.length === 1 }"
        class="handheld-version"
    >
        <div
            *ngIf="!resource.opensAsMediaGallery && resource.selectedAsset.medias.length > 1"
            class="available-language"
        >
            <div class="language-label">Choose Language</div>
            <app-language-selector
                (selectedItemChange)="changeLanguage($event)"
                [items]="resource.selectedAsset.medias"
                [selectedItem]="resource.getSelectedMedia()"
            >
            </app-language-selector>
        </div>
        <div class="align-left">
            <a
                (click)="downloadTranscript($event)"
                *ngIf="
                    !resource.opensAsMediaGallery &&
                    resource.selectedAsset?.selectedMedia &&
                    resource.selectedAsset.selectedMedia.hasTranscript()
                "
                aria-controls="nav-transcript"
                aria-selected="false"
                class="nav-item nav-link transcript selenium-tab-transcript"
                [ngClass]="{
                    'd-flex align-baseline justify-content-end': resourceService.focusView,
                }"
                href="#"
                rel="noopener noreferrer"
                target="_blank"
            >
                <i class="fas pbslm-transcript pr4"></i>Transcript
            </a>
            <a
                (click)="download($event)"
                *ngIf="
                    !resource.opensAsMediaGallery &&
                    !resourceService.focusView &&
                    !isAddonView &&
                    resource.selectedAsset?.selectedMedia &&
                    resource.selectedAsset.selectedMedia.download?.is_downloadable
                "
                [attr.data-gtmlabel]="window.location.href"
                [ngbTooltip]="
                    !userService.isLoggedIn() ? 'Sign in to download this resource' : null
                "
                aria-controls="nav-download"
                aria-selected="false"
                href="#"
                class="{{ gtmPrefix }}-download nav-item nav-link download selenium-download"
            >
                <i class="fas fa-download"></i>Download
            </a>
            <a
                [ngClass]="{ 'preview-color': isInPreviewMode$ | async }"
                (click)="redirectToResourceTypeView()"
                *ngIf="
                    !resource.opensAsMediaGallery &&
                    (userService.hasStudentExperience() || !isTeacherPreview) &&
                    resource.selectedAsset.selectedMedia &&
                    resource.opensAsVideo
                "
                aria-controls="nav-focus-view"
                aria-selected="false"
                class="nav-item nav-link focus-view selenium-tab-focus-view"
                rel="noopener noreferrer"
            >
                <i
                    [ngClass]="{
                        'fas pbslm-focus-view pr4': !resourceService.focusView,
                        'fas pbslm-full-view pr4': resourceService.focusView,
                    }"
                >
                </i>
                {{
                    (resourceService.focusView && windowSize.isMobile && "Full view") ||
                        (resourceService.focusView &&
                            !windowSize.isMobile &&
                            "Full Resource View ") ||
                        "Focus View"
                }}
            </a>
        </div>
    </div>
    <div
        *ngIf="!resourceService.focusView"
        class="nav nav-tabs resource-details"
        id="nav-tab"
        role="tabList"
    >
        <button
            (click)="changeTab(OVERVIEW)"
            *ngIf="resource.isLessonPlan"
            [ngClass]="{ active: isTabActive(OVERVIEW) }"
            class="nav-item nav-link selenium-tab-overview"
        >
            {{ OVERVIEW }}
        </button>
        <button
            (click)="changeTab(PROCEDURE)"
            *ngIf="
                resource.isLessonPlan &&
                isTeacherPreview &&
                resource.lessonData.procedureData.length
            "
            [ngClass]="{ active: isTabActive(PROCEDURE) }"
            class="nav-item nav-link selenium-tab-procedure"
        >
            {{ PROCEDURE }}
        </button>
        <button
            (click)="changeTab(ABOUT)"
            *ngIf="!resource.isLessonPlan"
            [attr.data-gtmlabel]="window.location.href"
            [ngClass]="{ active: isTabActive(ABOUT) }"
            class="{{ gtmPrefix }}-about nav-item nav-link active selenium-tab-about"
        >
            {{ ABOUT }}
        </button>
        <button
            (click)="changeTab(STANDARDS)"
            *ngIf="hasStandards && isTeacherPreview"
            [attr.data-gtmlabel]="window.location.href"
            [ngClass]="{ active: isTabActive(STANDARDS) }"
            class="{{ gtmPrefix }}-standards nav-item nav-link standards selenium-tab-standards"
        >
            {{ STANDARDS }}
        </button>
        <button
            (click)="changeTab(CAUTION_FLAGS)"
            *ngIf="hasContentFlags && isTeacherPreview"
            [ngClass]="{ active: isTabActive(CAUTION_FLAGS) }"
            class="{{
                gtmPrefix
            }}-caution-flags gtm-cautions-tab nav-item nav-link caution-flags selenium-tab-caution-flags"
        >
            {{ CAUTION_FLAGS }}
        </button>
    </div>
</nav>

<div
    *ngIf="!resourceService.focusView"
    class="tab-content gtmsection-resource-details-selected-tab"
    id="nav-tabContent"
>
    <div
        *ngIf="resource.isLessonPlan"
        [ngClass]="{ 'show active': isTabActive(OVERVIEW) }"
        class="tab-pane fade"
    >
        <ng-container [ngTemplateOutlet]="overviewTemplateRef"></ng-container>
    </div>
    <div
        *ngIf="resource.isLessonPlan"
        [ngClass]="{ 'show active': isTabActive(PROCEDURE) }"
        class="tab-pane fade"
    >
        <ng-container [ngTemplateOutlet]="procedureTemplateRef"></ng-container>
    </div>
    <div
        *ngIf="!resource.isLessonPlan"
        [ngClass]="{ 'show active': isTabActive(ABOUT) }"
        class="tab-pane fade"
    >
        <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-9 col-lg-9 resource-description">
                <div
                    *ngIf="resource.selectedAsset.selectedMedia.showFlashWarning"
                    class="flash-warning"
                >
                    <div class="icon">
                        <app-icon type="Info"></app-icon>
                    </div>
                    <div class="text">
                        Viewing this resource requires enabling the Adobe Flash player in your
                        browser. See our
                        <a
                            href="/help/technical-requirements/"
                            rel="noopener noreferrer"
                            target="_blank"
                        >
                            help pages
                        </a>
                        for instructions. Because this technology is being phased out, resources
                        currently in Flash will be retired or converted by December 2020.
                    </div>
                </div>
                <p [innerHtml]="setLinkTargets(resource.description) | bypassSecurity: 'html'"></p>
                <div *ngIf="resource.moreAboutThisResource" class="more-about-this">
                    More About This Resource
                </div>
                <p [innerHtml]="resource.moreAboutThisResource | bypassSecurity: 'html'"></p>
                <ng-container *ngIf="resource.shouldShowContentWarnings">
                    <p>{{ resource.getSensitiveWarning() }}</p>
                </ng-container>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3">
                <app-link
                    *ngIf="resource.brand && resource.brand.getLogo() && isTeacherPreview"
                    [appRouterLink]="isAddonView ? '/add-on/search' : '/search'"
                    [attr.data-gtmlabel]="resource.brand.name"
                    [queryParams]="brandSearchQueryParams"
                    class="brand-logo gtm-brand-logo selenium-brand-logo"
                >
                    <img alt="{{ resource.brand.name }}" src="{{ resource.brand.getLogo() }}" />
                </app-link>
                <img
                    *ngIf="!isTeacherPreview"
                    class="preview-brand-logo"
                    alt="{{ resource.brand.name }}"
                    src="{{ resource.brand.getLogo() }}"
                />
                <div
                    *ngIf="resource.selectedAsset.permittedUse"
                    class="permitted-use selenium-permitted-use"
                >
                    <span>Permitted use</span>
                    {{ resource.selectedAsset.permittedUse }}
                </div>
                <div
                    *ngIf="resource.accessibility && resource.accessibility.length"
                    class="accessibility selenium-accessibility"
                >
                    <span>Accessibility</span>
                    {{ getAccessibilities() }}
                </div>
                <app-link
                    *ngIf="resource?.creditsLink"
                    [href]="resource?.creditsLink"
                    target="_blank"
                    class="mt-4 {{ gtmPrefix }}-credits selenium-{{ gtmPrefix }}-credits"
                    >Credits
                </app-link>
            </div>
        </div>
    </div>
    <div
        *ngIf="hasStandards"
        class="tab-pane fade"
        [ngClass]="{ 'show active': isTabActive(STANDARDS) }"
    >
        <div class="standards-section">
            <app-standards-section
                id="resource-standards-tab"
                [standardsInformation]="standardsInfo"
                class="col standards-column"
            >
            </app-standards-section>
            <app-support-material-panel
                *ngIf="windowSize.isDesktop && resource.isLessonPlan"
                [resource]="resource"
            >
            </app-support-material-panel>
        </div>
    </div>
    <div
        *ngIf="hasContentFlags"
        [ngClass]="{ 'show active': isTabActive(CAUTION_FLAGS) }"
        class="tab-pane fade"
    >
        <div class="caution-flags-service mt-6">
            {{ cautionTabAssetDescription }} sensitive content. Select a tag for a detailed
            description.
            <div class="my-4" *ngIf="resource.shouldShowContentWarnings">
                <div *ngFor="let asset of resource.assets">
                    <ng-container
                        *ngIf="asset.contentFlags.length"
                        [ngTemplateOutlet]="cautionFlagsDisplay"
                        [ngTemplateOutletContext]="{
                            selectedCautionFlags: assetCautionFlags(asset),
                            assetName: asset.title,
                        }"
                    >
                    </ng-container>
                </div>
                <div *ngFor="let lessonContent of resource.lessonContents">
                    <ng-container
                        *ngIf="lessonContent.contentFlags.length"
                        [ngTemplateOutlet]="cautionFlagsDisplay"
                        [ngTemplateOutletContext]="{
                            selectedCautionFlags: lessonPlanAssetCautionFlags(lessonContent),
                            assetName: lessonContent.title,
                        }"
                    >
                    </ng-container>
                </div>
            </div>
            Find out more about
            <a href="/help/caution-flags" rel="noreferrer noopener" class="help-link">
                how the PBS LearningMedia team assesses sensitive content on this Help page.
            </a>
        </div>
    </div>
    <app-support-material-panel
        *ngIf="windowSize.isTablet && !resource.isLessonPlan"
        [resource]="resource"
    >
    </app-support-material-panel>
    <div *ngIf="tabList.length > 1" class="tab-nav-button-wrapper">
        <app-button
            *ngIf="hasPrevTab()"
            (click)="selectPrevTab()"
            [gtmLabel]="getPrevTabName()"
            buttonClasses="selenium-previous-tab gtm-previous-tab"
            class="tab-nav-button"
        >
            <app-icon [type]="'Arrow-left2'"></app-icon>
            Previous: {{ getPrevTabName() }}
        </app-button>
        <app-button
            *ngIf="hasNextTab() && !isAddonView"
            (click)="selectNextTab()"
            [gtmLabel]="getNextTabName()"
            buttonClasses="selenium-next-tab gtm-next-tab"
            class="tab-nav-button"
        >
            Next: {{ getNextTabName() }}
            <app-icon [type]="'Arrow-right2'"></app-icon>
        </app-button>
    </div>
</div>
<ng-template
    #cautionFlagsDisplay
    let-selectedCautionFlags="selectedCautionFlags"
    let-title="assetName"
>
    <h4
        class="asset-title mb-2"
        *ngIf="resource.opensAsMediaGallery || resource.lessonContents.length"
    >
        {{ title }}
    </h4>
    <!--  This pipe call and pipe itself will be removed and the BE response - (not decided yet)
    -  will be mapped by a new FE model for caution flags with @name, @description -->
    <ng-container *ngFor="let cautionFlag of selectedCautionFlags">
        <mat-chip
            *ngIf="cautionFlag.description.length"
            [ngClass]="{
                'mt-2 mb-7': resource.opensAsMediaGallery || resource.lessonContents.length,
            }"
            ngbTooltip="{{ cautionFlag.description }}"
            [placement]="innerWidth < 992 ? 'top-left' : 'top'"
            class="me-4 my-2"
        >
            {{ cautionFlag.name }}
        </mat-chip>
    </ng-container>
</ng-template>
